require("./DateSelector.less");

const React = require("react");
const moment = require("moment");

const Comment = require("../Comment/Comment.jsx");
const Task = require("../Task/Task.jsx"); 
const QuestionType = require("~/types/Question.js").PropType;
const NewAnswerSelection = require("~/types/AnswerSelection.js").New;

const defaultDateInputFormat = "M/D/YYYY";
const longDateFormat = "dddd, D MMMM YYYY";

const DateSelector = React.createClass({
    propTypes: {
        Question: QuestionType.isRequired,
        OnAnswerChange: React.PropTypes.func.isRequired
    },
    getInitialState() {
        const firstSelection = (this.props.Question.AnswerSelections || [])[0];

        const parsed = moment(firstSelection.SelectionText);
        const initialDate = parsed.isValid() ? parsed.format(defaultDateInputFormat) : "";

        if (firstSelection) {
            return {
                AnswerSelection: NewAnswerSelection(
                    initialDate,
                    firstSelection.AdditionalComment,
                    firstSelection.GUID,
                    firstSelection.SelectionScoreValue),
                AdditionalComment: this.props.Question.AdditionalComment,
                Task: this.props.Question.Task
            }
        }
        else {
            return {
                AnswerSelection: NewAnswerSelection(initialDate),
                AdditionalComment: this.props.Question.AdditionalComment,
                Task: this.props.Question.Task
            };
        }
    },
    render() {
        const showCommentField = this.props.Question.IncludeComment;

        const parsed = moment(this.state.AnswerSelection.SelectionText);

        const confirmationDate = parsed.isValid()
            ? parsed.format(longDateFormat)
            : "";

        return (<div className="form-group">
            <header className="cs-DateSelector__question"
                    dangerouslySetInnerHTML={{ __html: this.props.Question.DisplayHTML }}></header>
            <div className="cs-DateSelector__answerBox">
                <label>
                    Answer:
                </label><br />
                <input className="form-control" value={this.state.AnswerSelection.SelectionText}
                       onChange={this.AnswerChanged}
                       placeholder="MM/DD/YYYY" />
                <div className="cs-DateSelector__confirmation">
                    {confirmationDate}
                </div>
            </div>
            <div className="cs-DateSelector__answerBox--print">
                <label>Answer: </label><br />
                <p>{this.DisplayAnswer(this.state.AnswerSelection.SelectionText)}</p>
            </div>
            {showCommentField && (
            <Comment OnChange={this.OnCommentChange} Comment={this.state.AdditionalComment} />)}
            <Task OnChange={this.OnTaskChange} Task={this.state.Task}></Task>
        </div>);
    },
    AnswerChanged(e) {
        let text = "";

        if (e) {
            text = e.target.value;
        }

        const answer = Object.assign({}, this.state.AnswerSelection, {
            SelectionText: text
        });

        this.props.OnAnswerChange([answer], this.state.AdditionalComment);

        this.setState({
            AnswerSelection: answer
        });
    },
    DisplayAnswer(answer) {
        if (answer === "") {
            return (<em>No answer entered</em>);
    }
    else {
        return answer;
    }
    },
    OnCommentChange(e) {
        this.props.OnAnswerChange([this.state.AnswerSelection], e.target.value, this.state.Task);

        this.setState({
            AdditionalComment: e.target.value
        });
    },
    OnTaskChange(e) {
        this.props.OnAnswerChange([this.state.AnswerSelection], this.state.AdditionalComment, e.target.value);

        this.setState({
            Task: e.target.value
        })
    }
});

module.exports = DateSelector;


// WEBPACK FOOTER //
// ./src/components/DateSelector/DateSelector.jsx